var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a-card', {
    attrs: {
      "bordered": false
    }
  }, [_c('a-form', {
    attrs: {
      "layout": "inline",
      "onSubmit": ""
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "活动界次"
    }
  }, [_c('j-dict-select-tag', {
    attrs: {
      "defaultShowAll": true,
      "type": "radioButton",
      "trigger-change": true,
      "dictCode": "event_orders",
      "placeholder": "请选择活动"
    },
    model: {
      value: _vm.queryParam.eventId,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "eventId", $$v);
      },
      expression: "queryParam.eventId"
    }
  })], 1)], 1), _c('a-divider'), _c('a-list', {
    attrs: {
      "dataSource": _vm.cmsDataSource
    }
  }, [_c('a-list', {
    attrs: {
      "item-layout": "vertical",
      "size": "large",
      "pagination": _vm.pagination,
      "data-source": _vm.cmsDataSource
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {
          key: "item.title"
        }, [_c('a-list-item-meta', {
          attrs: {
            "description": item.description
          }
        }, [_c('a', {
          attrs: {
            "slot": "title"
          },
          on: {
            "click": function click($event) {
              return _vm.toDetail(item);
            }
          },
          slot: "title"
        }, [_c('h3', {
          staticClass: "title"
        }, [_vm._v(_vm._s(item.cmsTitile))])])]), item.cmsDesc ? _c('p', [_vm._v("\n          " + _vm._s(item.cmsDesc) + "\n        ")]) : _vm._e(), _c('div', {
          staticClass: "cms-info"
        }, [_c('a-icon', {
          attrs: {
            "type": "clock-circle"
          }
        }), _c('span', {
          staticClass: "gap"
        }, [_vm._v(_vm._s(item.createTime))])], 1)], 1);
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._v("共" + _vm._s(_vm.info.total) + "篇 " + _vm._s(_vm.$route.query.kw ? '关键词：' + this.$route.query.kw : ''))])])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };